module.exports = __webpack_public_path__ + "img/vertical_6_4_3009.2adbd820.png";